var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _ellipse2, _path8, _path9, _path10, _path11, _rect3, _circle, _path12, _circle2, _path13, _circle3, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeepOceanThumbnailContrast = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 102,
    fill: "#E5E5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-background",
    x: 0.5,
    y: 0.5,
    width: 101,
    height: 101,
    rx: 10.5,
    fill: "white",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-character-outline",
    d: "M24.6359 53.5417C21.0557 55.5029 23.6595 66.7354 23.4967 68.1617L38.957 61.7432C35.3767 58.3556 27.5001 51.9727 24.6359 53.5417Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-character-outline",
    d: "M24.6359 95.359C21.0557 93.3977 23.6595 82.1653 23.4967 80.7389L38.957 87.1575C35.3767 90.5451 27.5001 96.9279 24.6359 95.359Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-character-outline",
    d: "M15.7039 75.0222C14.4796 71.8616 12.7657 64.9873 15.7039 62.7749C18.642 60.5625 16.9281 70.0179 15.7039 75.0222Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-character-outline",
    d: "M15.7039 75.0221C14.4796 77.8954 12.7657 84.1447 15.7039 86.156C18.642 88.1673 16.9281 79.5714 15.7039 75.0221Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-character-innerline-black",
    d: "M82.6188 57.8619C91.9225 59.9733 92.9997 65.5544 92.9997 73.8787L92.9999 74.3701C93.0049 86.4019 93.008 93.8879 65.4548 93.8879C38.4202 93.8879 19.1157 84.8041 17.9102 75.7341H17.0878C17.031 76.29 16.8938 76.8592 16.6378 77.4006C15.5465 79.7081 13 76.2469 13 75.0931C13 73.9394 16.2973 71.3755 16.6378 72.5293C16.7916 72.8907 16.9715 73.4876 17.0619 74.1958H17.8751C18.4277 67.0846 28.2415 61.9727 46.5018 59.1024C47.1771 56.8266 48.2787 53.6091 50.1213 52.2541C52.4867 50.5144 64.011 46.9305 69.3801 45.8822C68.9763 41.1087 69.1831 33.3329 71.5842 30.7176C74.894 27.1125 78.6187 27.074 81.1799 27.0475C81.7151 27.0419 82.1996 27.0369 82.6188 27C82.8964 27.4535 82.8274 28.2301 82.7364 29.2548C82.6816 29.8716 82.6188 30.5784 82.6188 31.3586C82.6188 31.7696 82.0187 31.7088 81.109 31.6167C79.465 31.4502 76.8098 31.1814 74.8582 33.4097C72.7609 35.8043 72.2053 41.727 72.2503 45.6063C75.7214 45.786 82.6188 47.3373 82.6188 52.2541V57.8619Z",
    fill: "#1E1E1E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-character-innerline-white",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.1341 50.152C82.1844 45.7848 75.9794 44.3933 72.2638 44.0315C72.248 44.5824 72.2439 45.1115 72.2496 45.6072C75.1674 45.7583 80.5061 46.8785 82.1341 50.152ZM69.2618 44.017C65.0154 44.6504 52.4489 48.2546 51.4547 49.3056C50.9373 49.8526 50.9054 50.8168 51.041 51.7072C54.6409 49.851 64.5255 46.8309 69.3795 45.8831C69.3302 45.3008 69.29 44.6738 69.2618 44.017Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-character-innerline-black",
    d: "M82.1341 50.152L81.2388 50.5973C81.4445 51.011 81.9069 51.2299 82.3573 51.1268C82.8076 51.0237 83.1288 50.6255 83.1341 50.1635L82.1341 50.152ZM72.2638 44.0315L72.3607 43.0363C72.0849 43.0094 71.8104 43.0982 71.6025 43.2814C71.3947 43.4646 71.2722 43.7259 71.2642 44.0028L72.2638 44.0315ZM72.2496 45.6072L71.2497 45.6188C71.2558 46.1465 71.6709 46.5786 72.1979 46.6059L72.2496 45.6072ZM69.2618 44.017L70.2609 43.9741C70.2487 43.6908 70.1169 43.4261 69.8983 43.2457C69.6796 43.0652 69.3947 42.9861 69.1143 43.0279L69.2618 44.017ZM51.4547 49.3056L52.1812 49.9928L51.4547 49.3056ZM51.041 51.7072L50.0524 51.8577C50.1008 52.176 50.2996 52.4516 50.5865 52.5979C50.8733 52.7443 51.2131 52.7436 51.4993 52.596L51.041 51.7072ZM69.3795 45.8831L69.5711 46.8646C70.072 46.7668 70.4189 46.3074 70.3759 45.7988L69.3795 45.8831ZM83.1341 50.1635C83.166 47.3907 81.178 45.6854 79.0345 44.6838C76.8745 43.6744 74.2637 43.2215 72.3607 43.0363L72.1669 45.0268C73.9796 45.2033 76.329 45.6271 78.1878 46.4957C80.0632 47.3721 81.1526 48.5461 81.1342 50.1405L83.1341 50.1635ZM71.2642 44.0028C71.248 44.567 71.2438 45.1095 71.2497 45.6188L73.2496 45.5956C73.244 45.1135 73.2479 44.5978 73.2634 44.0603L71.2642 44.0028ZM72.1979 46.6059C73.579 46.6774 75.5392 46.9807 77.3268 47.6459C79.1437 48.322 80.5938 49.3005 81.2388 50.5973L83.0295 49.7067C82.0465 47.73 80.0132 46.5116 78.0243 45.7715C76.0061 45.0205 73.838 44.6881 72.3013 44.6086L72.1979 46.6059ZM69.1143 43.0279C66.9179 43.3555 62.658 44.4323 58.8577 45.545C56.9491 46.1038 55.1319 46.6788 53.7223 47.1835C53.0191 47.4352 52.4029 47.6746 51.9221 47.8901C51.6823 47.9976 51.4624 48.1052 51.2762 48.2115C51.1093 48.3067 50.8956 48.4415 50.7282 48.6185L52.1812 49.9928C52.1381 50.0384 52.139 50.0219 52.2676 49.9485C52.3768 49.8862 52.5329 49.8081 52.7401 49.7152C53.1535 49.5299 53.7153 49.3103 54.3964 49.0664C55.7553 48.5799 57.5316 48.0172 59.4197 47.4644C63.2127 46.3539 67.3593 45.3118 69.4093 45.006L69.1143 43.0279ZM50.7282 48.6185C50.2736 49.0991 50.0832 49.706 50.0116 50.2463C49.9394 50.7921 49.9761 51.3568 50.0524 51.8577L52.0296 51.5567C51.9703 51.1672 51.9552 50.8046 51.9943 50.5089C52.0342 50.2078 52.1184 50.0592 52.1812 49.9928L50.7282 48.6185ZM51.4993 52.596C53.2149 51.7114 56.5121 50.5139 60.039 49.4087C63.5502 48.3084 67.1955 47.3284 69.5711 46.8646L69.1878 44.9016C66.7095 45.3856 62.9855 46.3895 59.4409 47.5002C55.912 48.6061 52.467 49.8468 50.5827 50.8184L51.4993 52.596ZM70.3759 45.7988C70.3279 45.2309 70.2885 44.6177 70.2609 43.9741L68.2627 44.0599C68.2915 44.7299 68.3325 45.3707 68.383 45.9674L70.3759 45.7988Z",
    fill: "#1E1E1E"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "thumbnail-character-innerline-black",
    rx: 14.4149,
    ry: 14.931,
    transform: "matrix(0.894018 0.448031 -0.409149 0.912468 62.2791 75.6669)",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "thumbnail-character-outline",
    rx: 9.17309,
    ry: 9.50153,
    transform: "matrix(0.894018 0.448031 -0.409149 0.912468 62.2792 75.6669)",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-character-innerline-white",
    d: "M42.8188 90.7795C39.2758 80.5293 41.3425 64.7316 42.8188 60.1322L40.2978 60.5302C37.6828 70.4847 38.7426 85.4251 39.9377 89.9834L42.8188 90.7795Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-character-innerline-white",
    d: "M84.6342 90.8094C80.8053 79.2378 83.9284 64.6282 85.8909 59.274L83.3774 58.4756C79.06 70.3373 79.3857 80.5872 82.1206 91.6078L84.6342 90.8094Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-character-innerline-white",
    d: "M91.3193 66.7685C91.3196 65.2149 88.9008 62.5798 87.6913 61.4564C86.0205 61.0783 86.3334 63.0913 87.221 63.5349C88.1086 63.9785 88.7086 66.1778 88.9955 67.8207C89.2824 69.4636 91.3189 68.7106 91.3193 66.7685Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-character-innerline-white",
    d: "M80.7881 52.4508C80.4001 50.8099 77.0695 48.605 75.4527 47.7076C73.5126 47.7076 74.3614 49.7587 75.4527 50.0151C76.5441 50.2715 77.7567 52.4508 78.4842 54.1173C79.2118 55.7838 81.2732 54.5019 80.7881 52.4508Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-character-innerline-white",
    x: 20.5708,
    y: 72.7354,
    width: 15.1416,
    height: 5.71691,
    rx: 2.85846,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-character-innerline-black",
    cx: 44.25,
    cy: 31.5,
    r: 6.75,
    fill: "#1E1E1E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-character-innerline-white",
    d: "M48.9693 31.4089C47.9847 32.7609 47.6751 30.4663 46.0786 29.3034C44.482 28.1406 42.2031 28.5499 43.1878 27.1979C44.1725 25.846 46.265 25.6927 47.8615 26.8555C49.458 28.0183 49.954 30.057 48.9693 31.4089Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-character-innerline-black",
    cx: 24.375,
    cy: 10.875,
    r: 4.875,
    transform: "rotate(-90 24.375 10.875)",
    fill: "#1E1E1E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-character-innerline-white",
    d: "M24.3092 7.46671C25.2856 8.17787 23.6284 8.40144 22.7886 9.5545C21.9488 10.7076 22.2444 12.3535 21.268 11.6423C20.2915 10.9311 20.1808 9.41988 21.0206 8.26682C21.8605 7.11376 23.3328 6.75554 24.3092 7.46671Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-character-innerline-black",
    cx: 16.875,
    cy: 39.375,
    r: 4.875,
    transform: "rotate(-90 16.875 39.375)",
    fill: "#1E1E1E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-character-innerline-white",
    d: "M16.8092 35.9667C17.7856 36.6779 16.1284 36.9014 15.2886 38.0545C14.4488 39.2076 14.7444 40.8535 13.768 40.1423C12.7915 39.4311 12.6808 37.9199 13.5206 36.7668C14.3605 35.6138 15.8328 35.2555 16.8092 35.9667Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeepOceanThumbnailContrast);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/DeepOceanThumbnail-contrast.85b0e4c5d5c9e72550058fd0594d2007.svg";